<template>
    <div class="printOrderDetails">
        <!-- 订单状态 -->
        <div class="detailsState">
            <div class="detailsState_one">
                <i
                    class="el-icon-arrow-left"
                    @click="$router.go(-1)"
                ></i>
                <p class="detailsState_one_title">订单状态</p>
                <span v-if="processStatus==='UN_CONFIRM'">您已下单，待商家确认</span>
                <span v-if="processStatus==='UN_PAY'">商家已确认，待付款</span>
                <span v-if="processStatus==='OFFLINE_UN_CONFIRM'">线下支付待确认</span>
                <span v-if="processStatus==='DELIVERY_ON_CASH_UN_CONFIRM'">货到付款待确认</span>
                <span v-if="processStatus==='UN_SEND'">您已付款，待商家发货</span>
                <span v-if="processStatus==='UN_RECEIVE'">商家已发货，待您确认</span>
                <span v-if="processStatus==='UN_APPRAISE'">交易已成功</span>
                <span v-if="processStatus==='UN_CANCEL'">交易已取消</span>
            </div>
            <div class="detailsState_one">
                <p v-if="processStatus==='UN_CONFIRM'">
                    商家在{{day}}天{{hr}}小时{{min}}分{{sec}}秒内未确认，则系统将自动取消订单
                </p>
                <p v-if="processStatus==='UN_PAY'">
                    请在{{day}}天{{hr}}小时{{min}}分{{sec}}秒内付款，若未及时付款，系统将自动取消订单
                </p>
                <p v-if="processStatus==='OFFLINE_UN_CONFIRM'">
                    您可以通过消息联系商家确认支付结果
                </p>
                <p v-if="processStatus==='DELIVERY_ON_CASH_UN_CONFIRM'">
                    您可以通过消息联系商家确认支付方式
                </p>
                <p v-if="processStatus==='UN_SEND'">
                    您可以通过消息联系商家确认发货时间
                </p>
                <p v-if="processStatus==='UN_RECEIVE'">
                    您还有{{day}}天{{hr}}小时{{min}}分{{sec}}秒来确认收货，超时订单自动确认收货
                </p>
                <p v-if="processStatus==='UN_APPRAISE'">
                    交易已成功，请给商家评价
                </p>
            </div>
        </div>
        <!-- 报价流程 -->
        <div class="details">
            <div class="detailsProcess">
                <div class="processItem" v-if="processStatus!=='UN_CANCEL' && orderBase.payType == 'OFFLINE_PAY' && orderBase.payChannel == 'TRANSFER'" v-for="(item,index) in processList1" :key="index">
                    <div :class="processStatus === item.id?'process_type process_type2':'process_type'">
                        <i>{{index + 1}}</i>
                        <p>{{item.name}}</p>
                    </div>
                    <i class="el-icon-arrow-right typeIcon" v-show="item.id !== 'FINISHED'"></i>
                </div>
                <div class="processItem" v-if="processStatus!=='UN_CANCEL' && orderBase.payType == 'DELIVERY_ON_CASH' && orderBase.payChannel == 'DELIVERY_ON_CASH'" v-for="(item,index) in processList2" :key="index">
                    <div :class="processStatus === item.id?'process_type process_type2':'process_type'">
                        <i>{{index + 1}}</i>
                        <p>{{item.name}}</p>
                    </div>
                    <i class="el-icon-arrow-right typeIcon" v-show="item.id !== 'FINISHED'"></i>
                </div>
                <div class="processItem" v-if="processStatus!=='UN_CANCEL' && orderBase.payType !== 'OFFLINE_PAY' && orderBase.payChannel !== 'TRANSFER' && orderBase.payType !== 'DELIVERY_ON_CASH' && orderBase.payChannel !== 'DELIVERY_ON_CASH'" v-for="(item,index) in processList" :key="index">
                    <div :class="processStatus === item.id?'process_type process_type2':'process_type'">
                        <i>{{index + 1}}</i>
                        <p>{{item.name}}</p>
                    </div>
                    <i class="el-icon-arrow-right typeIcon" v-show="item.id !== 'FINISHED'"></i>
                </div>
            </div>
            <!--收货/发票信息-->
            <div class="basicInformation">
                <div class="goodsReceiving">
                    <h3>收货信息</h3>
                    <div class="goodsItem">
                        <div class="name">收货地址：</div>
                        <div class="content">{{ payeeDetail.province }}{{ payeeDetail.city }}{{ payeeDetail.district }}{{ payeeDetail.areaInfo }}</div>
                    </div>
                    <div class="goodsItem">
                        <div class="name">收货人：</div>
                        <div class="content">{{ payeeDetail.receiverName }}</div>
                    </div>
                    <div class="goodsItem">
                        <div class="name">手机号码：</div>
                        <div class="content">{{ payeeDetail.mobile }}</div>
                    </div>
                </div>
                <div class="invoiceInformation" v-if="issueInvoice">
                    <h3>发票信息</h3>
                    <div class="goodsItem">
                        <div class="name">发票要求：</div>
                        <div class="content">{{ issueInvoice.issueType=='ZZFP'?'纸质发票':'电子发票' }}</div>
                    </div>
                    <div class="goodsItem">
                        <div class="name">发票类型：</div>
                        <div class="content">{{ invoiceInfo.invoiceType=='NORMAL'?'增值税普通发票':'增值税专用发票' }}</div>
                    </div>
                    <div class="goodsItem">
                        <div class="name">开票信息：</div>
                        <div class="content">{{ invoiceInfo.title }}
                            <el-popover
                                placement="right"
                                width="400"
                                trigger="click">
                                <div class="billingInformation ">
                                    <div class="title">开票信息</div>
                                    <div class="billingContent">
                                        <div class="billingItem">
                                            <div class="name">开票抬头：</div>
                                            <div class="content">{{ invoiceInfo.title }}</div>
                                        </div>
                                        <div class="billingItem" v-if="invoiceInfo.billType=='ENTERPRISE'">
                                            <div class="name">纳税人识别号：</div>
                                            <div class="content">{{ invoiceInfo.code }}</div>
                                        </div>
                                        <div class="billingItem" v-if="invoiceInfo.invoiceType=='SPECIAL'">
                                            <div class="name">地址：</div>
                                            <div class="content">{{ invoiceInfo.address }}</div>
                                        </div>
                                        <div class="billingItem" v-if="invoiceInfo.invoiceType=='SPECIAL'">
                                            <div class="name">电话：</div>
                                            <div class="content">{{ invoiceInfo.mobile }}</div>
                                        </div>
                                        <div class="billingItem" v-if="invoiceInfo.invoiceType=='SPECIAL'">
                                            <div class="name">开户行：</div>
                                            <div class="content">{{ invoiceInfo.bank }}</div>
                                        </div>
                                        <div class="billingItem" v-if="invoiceInfo.invoiceType=='SPECIAL'">
                                            <div class="name">账号：</div>
                                            <div class="content">{{ invoiceInfo.bankAccount }}</div>
                                        </div>
                                    </div>
                                </div>
                                <el-button type="text"  slot="reference" style="padding: 0 0 0 10px;">详细</el-button>
                            </el-popover>
                        </div>
                    </div>
                    <!--邮寄地址和电子邮箱根据发票类型显示其中一个-->
                    <div class="goodsItem" v-if="issueInvoice.issueType=='ZZFP'">
                        <div class="name">发票邮寄地址：</div>
                        <div class="content">{{ payeeInfo.province }}{{ payeeInfo.city }}{{ payeeInfo.district }}{{ payeeInfo.areaInfo }}</div>
                    </div>
                    <div class="goodsItem" v-else>
                        <div class="name">电子邮箱：</div>
                        <div class="content">{{ invoiceInfo.payeeEmail }}</div>
                    </div>
                </div>
                <div v-else>
                    <h3>发票信息</h3>
                    <div class="goodsItem">
                        <div class="name">暂未开具发票</div>
                    </div>
                </div>
            </div>
            <!--物流信息-->
            <div class="logisticsInformation">
                <h3>物流信息</h3>
                <div class="logisticsContent">
                    <div class="logisticsLeft">
                        <div class="orderItem" v-show="logisticsTrackVisible">
                            <div class="content">暂无物流信息</div>
                        </div>
                        <el-timeline v-show="!logisticsTrackVisible&&logisticsList.length>0">
                            <el-timeline-item :class="index === 0?'timelineItemActive':''" :timestamp="item.ftime" :color="index === 0?'#1890FF':'#B2B2B2'" placement="top" v-for="(item,index) in logisticsList" :key="index">
                                <div class="timelineItemClass">
                                    <el-button class="newest" v-if="index === 0">最新</el-button>
                                    <div class="content">{{item.context}}</div>
                                </div>
                            </el-timeline-item>
                        </el-timeline>
                        <div class="orderItem" v-show="!logisticsTrackVisible&&logisticsList.length==0">
                            <div class="content">{{ logisiticsResult }}({{ orderBase.logisticsUuid }}-{{ orderBase.logisticsNo }})</div>
                        </div>
                    </div>
                    <div class="logisticsRight"></div>
                </div>
            </div>
            <!--订单信息-->
            <div class="orderInformation">
                <div class="orderTop">
                    <h3>订单信息</h3>
                    <div class="orderItem">
                        <div class="name">服务商：</div>
                        <div class="content">{{ orderShopInfo.storeName }} <i class="iconfont icon-weixin" @click="startChat(orderShopInfo.enterPriseUuid)"></i></div>
                    </div>
                </div>
                <div class="orderBottom">
                    <div class="orderItem">
                        <div class="name">订单编号：</div>
                        <div class="content">{{ orderBase.orderNo }}</div>
                    </div>
                    <div class="orderItem">
                        <div class="name">创建时间：</div>
                        <div class="content">{{ orderBase.createDate }}</div>
                    </div>
                    <div class="orderItem" v-if="orderBase.payChannel!=null && orderBase.payType!=null">
                        <div class="name">付款时间：</div>
                        <div class="content">{{ orderBase.payDate }}</div>
                    </div>
                    <div class="orderItem" v-if="orderBase.payChannel!=null && orderBase.payType!=null">
                        <div class="name">付款渠道：</div>
                        <div class="content">
                            {{ orderBase.payChannelCn }}
                        </div>
                    </div>
                </div>
            </div>
            <!--打印信息-->
            <div class="printInformation">
                <h3>商品信息</h3>
                <div class="printTableContent">
                    <div class="tableHeader">
                        <div class="sort">序号</div>
                        <div class="name">商品信息</div>
                        <div class="price">单价</div>
                        <div class="num">数量</div>
                        <div class="num">实付款</div>
                    </div>
                    <div class="tableBody">
                        <div class="sort">
                            <div v-for="(item,index) in shopList" :key="index">{{ index+1>9?index+1:"0"+(index+1) }}</div>
                        </div>
                        <div class="name">
                            <div class="orderInfo" v-for="(item,index) in shopList" :key="index">
                                <img :src="item.specUrl" alt="">
                                <div class="infoContent">
                                    <div class="infoName">{{ item.goodsName }}-{{ item.specName }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="price">
                            <div  v-for="(item,index) in shopList" :key="index">
                                <p v-if="orderBase.activityUuid" style="text-decoration: line-through;color:#000;line-height:20px">¥ {{ item.goodsPrice }}</p>
                                <p v-if="orderBase.activityUuid" style="line-height:20px">¥ {{ item.price }}</p>
                                <p v-else>￥{{ item.price }}</p>
                            </div>
                        </div>
                        <div class="num">
                            <div v-for="(item,index) in shopList" :key="index">
                                {{ item.num }}
                            </div>
                        </div>
                        <div class="num">
                            <div>
                                {{ orderBase.updateTotalPrice }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--商品价格-->
            <div class="commodityPrices">
                <div class="priceItem">
                    <div class="name">小计：</div>
                    <div class="content">¥ {{ orderBase.updateTotalPrice }}</div>
                </div>
                <div class="priceItem">
                    <div class="name">运费：</div>
                    <div class="content">¥ {{ orderBase.transportationPrice }}</div>
                </div>
                <div class="priceItem fontWeight">
                    <div class="name">实付款：</div>
                    <div class="content">¥ {{ orderBase.totalPrice }}</div>
                </div>
            </div>
            <!--功能按钮-->
            <div class="functionButton" v-if="type !== 'evaluate'">
                <!--功能按钮-->
                <div class="functionButton">
                    <!--<el-button type="primary" v-show="processStatus === 'UN_CONFIRM'" @click="updateAddress(orderBase)">修改地址</el-button>-->
                    <el-button type="primary" v-show="processStatus === 'UN_PAY'" @click="submitPay">付款</el-button>
                    <el-button type="primary" v-show="processStatus === 'UN_CONFIRM' || processStatus === 'UN_PAY' || processStatus == 'OFFLINE_UN_CONFIRM' || processStatus == 'DELIVERY_ON_CASH_UN_CONFIRM'" @click="cancelOrder(orderBase)">取消订单</el-button>
                    <el-button type="primary" v-show="processStatus === 'UN_RECEIVE'" @click="takeDelivery(orderBase)">确认收货</el-button>
                    <el-button type="primary" v-show="processStatus === 'UN_APPRAISE'" @click="toEvaluate(orderShopInfo)">评价</el-button>
                    <el-button type="primary" v-show="processStatus !== 'UN_CONFIRM'
                    && processStatus !== 'UN_PAY'
                    && processStatus !== 'UN_CANCEL'
                    && processStatus !== 'AFTER_SALES'
                    && processStatus !== 'OFFLINE_UN_CONFIRM'
                    && (orderBase.afterSaleUuid===null || (orderBase.afterSaleUuid!==null&&orderBase.afterSaleAuditStatus==='REJECT'))
                    && orderBase.splitStatus === 'NONE'
                    && processStatus !== 'DELIVERY_ON_CASH_UN_CONFIRM'"
                               @click="AfterSales(orderBase.uuid,orderShopInfo.enterPriseUuid,orderShopInfo.storeName,processStatus,orderBase.totalPrice)">申请售后</el-button>
                    <el-button type="primary" v-show="processStatus !== 'UN_CONFIRM'
                    && processStatus !== 'UN_PAY' && processStatus !== 'UN_CANCEL'
                    && processStatus !== 'AFTER_SALES'
                    && orderBase.afterSaleAuditStatus !== 'PASS'
                    && processStatus !== 'DELIVERY_ON_CASH_UN_CONFIRM'
                    && orderShopInfo.invoiceType == null" @click="openInvoice(orderShopInfo)">申请开票</el-button>
                    <el-button type="primary" class="operationBtnMoney" v-if="processStatus == 'OFFLINE_UN_CONFIRM' || processStatus === 'UN_SEND' || processStatus === 'UN_RECEIVE' || processStatus === 'UN_APPRAISE' || processStatus === 'AFTER_SALES' || processStatus === 'FINISHED'" @click="complain(orderBase.uuid,orderShopInfo.enterPriseUuid,orderShopInfo.storeName)">投诉</el-button>
                </div>
            </div>
        </div>
        <!-- 修改价格 -->
        <order-shop-price-dialog ref="orderShopPriceRef" @updateOrderSuccess="getOrderShopInfo()"></order-shop-price-dialog>
        <!-- 取消订单 -->
        <cancel-order-shop-dialog ref="cancelOrderShopRef" @cancelOrderSuccess="getOrderShopInfo()"></cancel-order-shop-dialog>
        <!-- 申请开票 -->
        <issue-invoice-dialog ref="invoiceDialogRef" @invoiceAddressSuccess="getOrderShopInfo()"></issue-invoice-dialog>
        <!--评价弹出框-->
        <el-dialog title="评价" :visible.sync="evaluateDialogVisible" width="500px">
            <div class="evaluateDialogBox">
                <div class="evaluateItem">
                    <div class="name">评价等级</div>
                    <div class="content">
                        <div class="rateItem">
                            <div class="name">描述相符</div>
                            <el-rate
                                v-model="evaluateForm.descriptionPoint"
                                show-score
                                text-color="#ff9900"
                            >
                            </el-rate>
                        </div>
                        <div class="rateItem">
                            <div class="name">服务态度</div>
                            <el-rate
                                v-model="evaluateForm.servicePoint"
                                show-score
                                text-color="#ff9900"
                            >
                            </el-rate>
                        </div>
                        <div class="rateItem">
                            <div class="name">专业程度</div>
                            <el-rate
                                v-model="evaluateForm.transportPoint"
                                show-score
                                text-color="#ff9900"
                            >
                            </el-rate>
                        </div>
                    </div>
                </div>
                <div class="evaluateItem">
                    <div class="name">评价标签</div>
                    <div class="content">
                        <el-checkbox-group
                            v-model="evaluateForm.evaluationTagList"
                            class="evaluateTag"
                        >
                            <el-checkbox-button
                                v-for="tag in tagList"
                                :label="tag"
                                :key="tag.tagUuid"
                            >{{ tag.tagName }}
                            </el-checkbox-button
                            >
                        </el-checkbox-group>
                    </div>
                </div>
                <div class="evaluateItem">
                    <div class="name">评价内容</div>
                    <div class="content">
                        <el-input
                            type="textarea"
                            :autosize="{ minRows: 6 }"
                            placeholder="请输入内容"
                            v-model="evaluateForm.evaluationContent"
                        >
                        </el-input>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
        <el-button @click="evaluateDialogVisible = false">取 消</el-button>
        <el-button type="primary" :disabled="stepLoading" @click="evaluateSubmit">确 定</el-button>
      </span>
        </el-dialog>

        <!--聊天窗口-->
        <chat-dialog ref="chatDialogRef"></chat-dialog>
        <!-- 申请售后 -->
        <after-sales-dialog
            ref="afterSalesDialog"
        ></after-sales-dialog>
        <!-- 投诉弹窗 -->
        <complaints-dialog
            ref="dialogRef"
        ></complaints-dialog>
        <!-- 购买的弹窗 -->
        <PayModelDialog ref="payModelRef" @refreshData="getOrderShopInfo"/>
        <!-- 付款方式 -->
        <TermsOfPayment ref="termsOfPaymentRef" @offlinePay="offlinePayOrder"/>
    </div>
</template>

<script>
import cancelOrderShopDialog from './cancelOrderShop';
import orderShopPriceDialog from './orderShopPrice';
import issueInvoiceDialog from "./issueInvoiceDialog"
import PayModelDialog from "./payModelDialog"
import {
    getOrderShopInfo, getAddressDetail, updateOrderShopBaseInfo,
    findInvoiceInfo, getRongCloudUser, getLogisticsTrack,getDictionaryItem,saveEvaluation, offlinePay, deliveryOnCash, } from '../../../utils/interface';
import chatDialog from "../../../components/chat/chatDialog";
import afterSalesDialog from "./afterSalesDialog";
import {getIssueInvoiceByOrderId} from  '../../../utils/issueInvoice';
import complaintsDialog from './complaintsDialog'
import TermsOfPayment from '../../../components/termsOfPayment/termsOfPayment'
export default {
    name: "printOrderDetails",
    components: {
        cancelOrderShopDialog,
        orderShopPriceDialog,
        issueInvoiceDialog,
        chatDialog,
        afterSalesDialog,
        complaintsDialog,
        PayModelDialog,
        TermsOfPayment
    },
    data() {
        return {
            stepLoading: false,
            processStatus: '',
            processList: [
                {
                    id: "UN_CONFIRM",
                    name: "待确认",
                },
                {
                    id: "UN_PAY",
                    name: "待付款",
                },
                {
                    id: "UN_SEND",
                    name: "待发货",
                },
                {
                    id: "UN_RECEIVE",
                    name: "待收货",
                },
                {
                    id: "UN_APPRAISE",
                    name: "待评价",
                },
                {
                    id: "AFTER_SALES",
                    name: "退款/售后",
                },
                {
                    id: "FINISHED",
                    name: "完成",
                },
            ],
            processList1: [
                {
                    id: "UN_CONFIRM",
                    name: "待确认",
                },
                {
                    id: "UN_PAY",
                    name: "待付款",
                },
                {
                    id: "OFFLINE_UN_CONFIRM",
                    name: "线下支付待确认",
                },
                {
                    id: "UN_SEND",
                    name: "待发货",
                },
                {
                    id: "UN_RECEIVE",
                    name: "待收货",
                },
                {
                    id: "UN_APPRAISE",
                    name: "待评价",
                },
                {
                    id: "AFTER_SALES",
                    name: "退款/售后",
                },
                {
                    id: "FINISHED",
                    name: "完成",
                },
            ],
            processList2: [
                {
                    id: "UN_CONFIRM",
                    name: "待确认",
                },
                {
                    id: "UN_PAY",
                    name: "待付款",
                },
                {
                    id: "DELIVERY_ON_CASH_UN_CONFIRM",
                    name: "货到付款待确认",
                },
                {
                    id: "UN_SEND",
                    name: "待发货",
                },
                {
                    id: "UN_RECEIVE",
                    name: "待收货",
                },
                {
                    id: "UN_APPRAISE",
                    name: "待评价",
                },
                {
                    id: "AFTER_SALES",
                    name: "退款/售后",
                },
                {
                    id: "FINISHED",
                    name: "完成",
                },
            ],
            day: 0,
            hr: 0,
            min: 0,
            sec: 0,
            orderTechnologyList:[],
            logisticsCompanyList: [],
            logisticsList: [],
            logisticsUuid: '',
            logisticsNo: '',
            logisticsCompany:'',
            logisiticsResult:'',
            logisticsTrackVisible: true,
            payeeInfo:"",
            payeeDetail:"",
            invoiceInfo:"",
            type: '',
            issueInvoice:{},
            orderBaseUuid:"",
            orderShopInfo:{},
            orderBase:{},
            shopList:[],
            evaluateDialogVisible: false,
            evaluateForm: {
                descriptionPoint: 0,
                servicePoint: 0,
                transportPoint: 0,
                evaluationTagList: [],
                evaluationContent: "",
            },
            tagList: [
            ],
        }
    },
    created(){
        this.orderBaseUuid = this.$route.params.orderBaseUuid;
        this.getOrderShopInfo();
        this.getLogisticsCompanyList()
        this.getDictionaryItem();
    },
    mounted() {
        this.countdown()
    },
    methods: {
        // 获取字典值
        getDictionaryItem() {
            getDictionaryItem({groupCode: "shop_evaluation_tag"}).then((res) => {
                this.tagList = [];
                res.forEach((item, index) => {
                    this.tagList.push({tagName: item.name, tagUuid: item.code, tagGroupId: item.groupUuid});
                });
            });
        },
        // 点击打开评价弹出框
        toEvaluate(order) {
            this.order = order;
            console.log(order);
            this.evaluateForm = {
                descriptionPoint: 0,
                servicePoint: 0,
                transportPoint: 0,
                evaluationTagList: [],
                evaluationContent: "",
            };
            this.evaluateDialogVisible = true;
        },
        // 评价提交
        evaluateSubmit() {
            this.stepLoading = true;
            if (
                this.evaluateForm.descriptionPoint &&
                this.evaluateForm.servicePoint &&
                this.evaluateForm.transportPoint
            ) {
                this.evaluateForm.orderNo = this.order.orderBase.orderNo;
                this.evaluateForm.orderUuid = this.order.orderBase.uuid;
                this.evaluateForm.orderType = 'SHOP';
                this.evaluateForm.evaluationType = 'NORMAL';
                this.evaluateForm.sellerName = this.order.storeName;
                this.evaluateForm.sellerUuid = this.order.enterPriseUuid;
                this.evaluateForm.orderName = this.order.goodsName;
                this.evaluateForm.orderAmount = this.order.orderBase.totalPrice;

                saveEvaluation(this.evaluateForm).then((response) => {
                    if (response.success) {
                        this.evaluateDialogVisible = false;
                        this.getOrderShopInfo();
                        this.$message({
                            type: "success",
                            message: "评价成功",
                        });
                    } else {
                        this.$message({
                            type: "error",
                            message: response.message,
                        });
                    }
                });
            } else {
                this.$message.warning("请选择评价等级");
            }
            setTimeout(() => {
                this.stepLoading = false;
            }, 1000);
        },
        // 申请开票
        openInvoice(item){
            let params = {
                uuid:item.shopList[0].invoiceUuid,
                orderUuid:item.orderBase.uuid,
                orderNo:item.orderBase.orderNo,
                orderName:item.shopList[0].goodsName+"-"+item.shopList[0].specName,
                orderImg:item.shopList[0].specUrl,
                orderType:'SHOP',
                issueUser:item.userUuid,
                invoiceMoney:item.orderBase.updateTotalPrice,
            };
            this.$refs.invoiceDialogRef.init(params);
        },
        // 支付订单
        // 付款
        submitPay(){
            // 付款的选择弹窗
            this.$refs.termsOfPaymentRef.init()
            /*item.orderStatus = "UN_SEND";
            updateOrderShopBaseInfo(item).then((res)=>{
                if(res.success){
                    this.$message.success('订单支付成功！');
                    this.getOrderShopInfo();
                }
            });*/
        },
        //线下支付上传凭证
        offlinePayOrder(obj){
            if(obj.radio == 1){
                this.$refs.payModelRef.init();
                window.open(this.$url.payUrl + this.orderBase.orderNo, "_blank");
            } else if(obj.radio == 2 && obj.imageUrl != '' && obj.imageUrl != null){
                let form ={orderNo: this.orderBase.orderNo, orderBaseUuid: this.orderBase.uuid, payTicket: obj.imageUrl};
                offlinePay(form).then(res=> {
                    console.log(res);
                    if (res && res.success) {
                        this.$message.success(res.message);
                        this.getOrderShopInfo();
                    }else {
                        this.$message.error(res.message);
                    }
                });
            } else if(obj.radio == 3){
                let form ={orderNo: this.orderBase.orderNo, orderBaseUuid: this.orderBase.uuid};
                deliveryOnCash(form).then(res=> {
                    console.log(res);
                    if (res && res.success) {
                        this.$message.success(res.message);
                        this.getOrderShopInfo();
                    }else {
                        this.$message.error(res.message);
                    }
                });
            }
        },
        // 收货
        takeDelivery(item){
            this.$confirm('是否确认收货?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                item.orderStatus = "UN_APPRAISE";
                updateOrderShopBaseInfo(item).then((res)=>{
                    if(res.success){
                        this.$message.success('收货成功！');
                        this.getOrderShopInfo();
                    }
                });

            });
        },
        // 取消订单
        cancelOrder(item){
            this.$refs.cancelOrderShopRef.init(item);
        },
        getOrderShopInfo(){
            let params = {
                orderBaseUuid:this.orderBaseUuid
            };
            getOrderShopInfo(params).then((res)=>{
                if(res) {
                    this.orderShopInfo = res;
                    this.orderBase = res.orderBase;
                    this.processStatus = res.orderBase.orderStatus;
                    this.shopList = res.shopList;
                    if(this.orderBase.orderTimeType!=null&&this.orderBase.timeValue){
                        this.getDay(this.orderBase.orderTimeType);
                    }
                    //物流信息
                    if(this.orderBase.logisticsNo!=null&&this.orderBase.logisticsUuid!=null) {
                        this.viewLogisticsInfo(this.orderBase.uuid);
                    }
                    // 查询收货地址
                    if(this.shopList.length>0){
                        getAddressDetail({uuid:this.shopList[0].sendPostUuid}).then((res)=>{
                            this.payeeDetail = res;
                        });
                    }
                    // 开票信息
                    getIssueInvoiceByOrderId(this.orderBase.uuid).then((res)=>{
                        this.issueInvoice = res.data;
                        if(res.success){
                            if(this.issueInvoice.payeeUuid!=null){
                                getAddressDetail({uuid:this.issueInvoice.payeeUuid}).then((res)=>{
                                    this.payeeInfo = res;
                                });
                            }
                            // 收票地址信息
                            if(this.issueInvoice.invoiceUuid!= null){
                                findInvoiceInfo({uuid:this.issueInvoice.invoiceUuid}).then((res)=>{
                                    this.invoiceInfo = res;
                                });
                            }
                        }
                    });
                }
            });
        },
        // 选择确认后
        handleConfirm() {
            console.log("jjj");
        },
        getDay(timeType){
            if(timeType==='HOUR'){
                let editDate = new Date(this.orderBase.editDate);
                let countdownTime = editDate.getTime() + 1000 * 60 * 60 * Number(this.orderBase.timeValue);
                editDate.setTime(countdownTime);
                let tYear = editDate.getFullYear();
                let tMonth = editDate.getMonth();
                let tDate = editDate.getDate();
                let getHours = editDate.getHours();
                let getMinutes = editDate.getMinutes();
                let getSeconds = editDate.getSeconds();
                tMonth = this.doHandleMonth(tMonth + 1);
                tDate = this.doHandleMonth(tDate);
                let date = tYear + '-' + tMonth + '-' + tDate + ' ' + getHours + ':' + getMinutes + ':' + getSeconds;
                this.countdown(date);
            }
        },
        doHandleMonth (month) {
            let m = month;
            if (month.toString().length === 1) {
                m = '0' + month
            }
            return m
        },
        // 倒计时
        countdown(date) {
            // 定义结束时间戳
            let end = new Date(date);
            // 定义当前时间戳
            let now = new Date();
            // 做判断当倒计时结束时都为0
            if (now >= end) {
                this.day = 0;
                this.hr = 0;
                this.min = 0;
                this.sec = 0;
                return
            }
            // 用结束时间减去当前时间获得倒计时时间戳
            let msec = end - now;
            //算出天数
            let day = parseInt(msec / 1000 / 60 / 60 / 24);
            //算出小时数
            let hr = parseInt(msec / 1000 / 60 / 60 % 24);
            //算出分钟数
            let min = parseInt(msec / 1000 / 60 % 60);
            //算出秒数
            let sec = parseInt(msec / 1000 % 60);
            //给数据赋值
            this.day = day;
            this.hr = hr > 9 ? hr : '0' + hr;
            this.min = min > 9 ? min : '0' + min;
            this.sec = sec > 9 ? sec : '0' + sec;
            setTimeout(()=> {
                //this.countdown(date);
                this.getDay(this.orderBase.orderTimeType);
            }, 1000)
        },
        startChat(targetUuid) {
            let user = this.$store.state.userMessages;
            getRongCloudUser(targetUuid).then(res=> {
                this.$refs.chatDialogRef.init(user.uuid,user.name,user.headUrl,targetUuid,res.name,res.headUrl);
            });
        },
        // 申请售后
        AfterSales(orderBaseUuid, targetUserUuid, enterPriseName, orderStatus, orderPrice){
            this.$refs.afterSalesDialog.init(orderBaseUuid, targetUserUuid, enterPriseName, 'SHOP', orderStatus, orderPrice)
        },
        getLogisticsCompanyList(){
            getDictionaryItem({groupCode:'delivery_type'}).then(res=>{
                this.logisticsCompanyList=res;
            });
        },
        //投诉
        complain(orderBaseUuid, targetUserUuid, enterPriseName) {
            this.$refs.dialogRef.init(orderBaseUuid, targetUserUuid, enterPriseName);
        },
        // 查看实时物流
        viewLogisticsInfo(uuid,logisticsNo,logisticsUuid){

            this.logisticsList=[]
            this.logisticsUuid=''
            this.logisticsNo= ''
            this.logisticsCompany=''

            let params = {
                uuid:uuid,
                logisticsNo:logisticsNo,
                logisticsUuid:logisticsUuid
            };
            getLogisticsTrack(params).then((res)=>{
                if(res.success){
                    if(res.data.status === '200'){
                        //接口查询成功
                        this.logisticsTrackVisible = false;
                        this.logisticsNo = res.data.nu;
                        this.logisticsCompany = this.logisticsCompanyList.find(i => i.code === res.data.com)
                        this.logisticsList = res.data.data
                    }else{
                        this.logisticsTrackVisible = false;
                        this.logisiticsResult = res.data.message;
                        this.$message({
                            type: 'warning',
                            message: res.data.message
                        });
                    }
                }else{
                    this.logisticsTrackVisible = true;
                }
            });
        },
    },
}
</script>

<style scoped lang="less">
    p {
        margin: 0;
    }
    i {
        font-style: normal;
    }
    .printOrderDetails {
        background: #f5f5f5;
        // 订单状态
        .detailsState {
            background: #fff;
            font-size: 14px;
            padding: 26px 32px;
            margin-bottom: 8px;
            .detailsState_one {
                display: flex;
                align-items: center;
                position: relative;
                &:nth-of-type(1) {
                    margin-bottom: 16px;
                }
                i {
                    font-size: 18px;
                    margin-right: 5px;
                    cursor: pointer;
                    position: absolute;
                    left: -24px;
                }
                span{
                    color: rgba(0,0,0,.5);
                }
                .detailsState_one_title {
                    font-size: 16px;
                    font-weight: 700;
                    margin-right: 8px;
                }
                .detailsState_one_time {
                    color: #1890ff;
                }
            }
        }
        // 报价流程
        .details {
            background: #fff;
            padding: 0 8px 150px;
            .detailsProcess {
                border-bottom: 1px solid #efefef;
                display: flex;
                align-items: center;
                .processItem{
                    display: flex;
                    align-items: center;
                    /*  cursor: pointer;
                      &:hover{
                          .process_type{
                              i {
                                  background: #1890ff;
                                  color: #fff;
                                  border: 1px solid #1890ff;
                              }
                              p {
                                  color: #000;
                              }
                          }
                      }*/
                }
                .process_type {
                    width: 190px;
                    height: 64px;
                    // line-height: 64px;
                    display: flex;
                    align-items: center;
                    // border-bottom: 2px solid #1890ff;
                    text-align: center;
                    justify-content: center;
                    i {
                        display: inline-block;
                        width: 24px;
                        height: 24px;
                        border: 1px solid rgba(0, 0, 0, 0.15);
                        border-radius: 50%;
                        color: rgba(0, 0, 0, 0.15);
                        line-height: 27px;
                        font-size: 14px;
                        margin-right: 8px;
                    }
                    p {
                        font-size: 16px;
                        color: rgba(0, 0, 0, 0.3);
                    }
                }
                .typeIcon {
                    color: rgba(0, 0, 0, 0.3);
                    font-size: 18px;
                }
                .process_type2 {
                    border-bottom: 3px solid #1890ff;
                    i {
                        background: #1890ff;
                        color: #fff;
                        border: 1px solid #1890ff;
                    }
                    p {
                        color: #000;
                    }
                }
            }

            //发票信息样式
            .invoiceCenter{
                padding: 25px 32px;
                border-bottom: 1px solid #ddd;
                h3{
                    color: rgba(0, 0, 0, 0.85);
                    font-size: 16px;
                }
                .goodsItem{
                    display: flex;
                    font-size: 14px;
                    padding-bottom: 14px;
                    .name{
                        color: rgba(0, 0, 0, 0.85);
                    }
                    .content{
                        color: rgba(0, 0, 0, 0.65);
                    }
                }
            }
            .basicInformation{
                display: flex;
                padding: 25px 32px;
                border-bottom: 1px solid #ddd;
                h3{
                    margin: 0;
                    font-size: 16px;
                    font-weight: 700;
                    color: rgba(0, 0, 0, 0.85);
                    line-height: 24px;
                    padding-bottom: 20px;
                }
                .goodsItem{
                    display: flex;
                    padding-bottom: 14px;
                    font-size: 14px;
                    .name{
                        color: rgba(0, 0, 0, 0.85);
                        min-width: 80px;
                    }
                    .content{
                        color: rgba(0, 0, 0, 0.65);
                    }
                }
                .goodsReceiving{
                    width: 50%;
                    padding-right: 32px;
                    // border-right: 1px solid #ddd;
                }
                .invoiceInformation{
                    width: 50%;
                    padding-left:32px;
                }
            }
            .logisticsInformation{
                padding: 25px 32px;
                // padding-left: 32px;
                border-bottom: 1px solid #ddd;
                h3{
                    margin: 0;
                    font-size: 16px;
                    font-weight: 700;
                    color: rgba(0, 0, 0, 0.85);
                    line-height: 24px;
                    padding-bottom: 20px;
                }
                .logisticsContent{
                    display: flex;
                    .logisticsLeft{
                        /deep/.el-timeline-item__wrapper{
                            padding-left: 80px;
                        }
                        .timelineItemActive{
                            /deep/.el-timeline-item__timestamp{
                                color: #1890FF;
                            }
                            .content{
                                color: #1890FF;
                            }
                            .timelineItemClass{
                                position: relative;
                                button{
                                    position: absolute;
                                    left: -58px;
                                    top: -21px;
                                    width: 44px;
                                    height: 24px;
                                    background: #1890FF;
                                    border-radius: 2px;
                                    padding: 0;
                                    text-align: center;
                                    line-height: 24px;
                                    color: #fff;
                                    font-size: 12px;
                                    border: none;
                                    cursor: default;
                                }
                            }
                        }
                        .timelineItemClass{
                            font-size: 14px;
                        }
                        /deep/.el-timeline-item{
                            padding-bottom:30px;
                        }
                    }
                }
            }
            .orderInformation{
                padding: 25px 32px;
                border-bottom: 1px solid #ddd;
                h3{
                    margin: 0;
                    font-size: 16px;
                    font-weight: 700;
                    color: rgba(0, 0, 0, 0.85);
                    line-height: 24px;
                    padding-bottom: 20px;
                }
                .orderTop{
                    display: flex;
                    .orderItem{
                        padding-left: 50px;
                        i{
                            color: #1890FF;
                            padding-left: 10px;
                            cursor: pointer;
                        }
                    }
                }
                .orderBottom{
                    display: flex;
                    .orderItem{
                        display: flex;
                        align-items: center;
                        margin-right: 20px;
                    }
                }
                .orderItem{
                    font-size: 14px;
                    display: flex;
                    // width: 20%;
                    .name{
                        color: rgba(0, 0, 0, 0.85);
                    }
                    .content{
                        color: rgba(0, 0, 0, 0.65);
                    }
                }
            }
            .printInformation{
                padding: 25px 32px;
                border-bottom: 2px dashed #000;
                h3{
                    margin: 0;
                    font-size: 16px;
                    font-weight: 700;
                    color: rgba(0, 0, 0, 0.85);
                    line-height: 24px;
                    padding-bottom: 20px;
                }
                .printTableContent{
                    .tableHeader{
                        display: flex;
                        height: 54px;
                        background:rgba(0,0,0,.02);
                        line-height: 54px;
                        font-size: 14px;
                        color: #000000;
                    }
                    .tableBody{
                        display: flex;
                        align-items: center;
                        .name{
                            text-align: left;
                        }
                        .explain {
                            padding: 20px;
                        }
                        .sort,.price,.num{
                            div{
                                line-height: 204px;
                            }
                        }
                        .price{
                            color: #E42424;
                        }
                        .argumentsName {
                            padding-bottom: 8px;
                            font-size: 14px;
                            span{
                                color: rgba(51, 51, 51, 0.85);
                            }
                        }
                    }
                    .orderInfo {
                        padding: 50px 20px;
                        display: flex;
                        justify-content: center;
                        img {
                            display: block;
                            width: 100px;
                            height: 100px;
                            border-radius: 10px;
                            margin-right: 30px;
                        }

                        .infoContent {
                            .infoName {
                                font-size: 14px;
                                color: #000000;
                                padding-bottom: 10px;
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                max-width: 550px;
                            }

                            .infoOther {
                                font-size: 13px;
                                color: #999999;
                                padding-bottom: 8px;
                            }
                        }
                    }
                    .sort{
                        width: 60px;
                        text-align: center;
                        padding: 0 10px;
                    }
                    .name{
                        flex: 1;
                        text-align: center;
                        padding: 0 10px;
                        min-width: 600px;
                    }
                    .explain{
                        text-align: center;
                        padding: 0 10px;
                        width: 400px;
                    }
                    .price{
                        text-align: center;
                        padding: 0 10px;
                        width: 150px;
                    }
                    .num{
                        text-align: center;
                        padding: 0 10px;
                        width: 150px;
                    }
                }
            }
            .commodityPrices{
                padding: 20px 30px 0 0;
                .priceItem{
                    display: flex;
                    justify-content: flex-end;
                    padding-bottom: 15px;
                    font-size: 14px;
                    color: #404040;
                    .content{
                        min-width: 100px;
                        text-align: right;
                    }
                    &.fontWeight{
                        font-weight: 700;
                        .content{
                            color: #FF375F;
                        }
                    }
                }
            }
            .functionButton{
                position: fixed;
                bottom: 20px;
                right: 30px;
            }
        }
    }
    .billingInformation{
        .title{
            color: rgba(0, 0, 0, 0.85);
            padding: 5px 0 10px 15px;
            border-bottom: 1px solid #ddd;
            font-weight: 700;
        }
        .billingContent{
            padding: 10px 10px 0;
            color: rgba(0, 0, 0, 0.65);
            .billingItem{
                display: flex;
                padding-bottom: 10px;
            }
        }
    }
    .evaluateDialogBox {
        .evaluateItem {
            .name {
                font-size: 14px;
                color: #000;
                padding-bottom: 20px;
                font-weight: bold;
            }

            .content {
                padding-left: 20px;
                padding-bottom: 15px;
            }

            .rateItem {
                display: flex;
                align-items: center;
                padding-bottom: 15px;

                .name {
                    padding: 0 20px 0 0;
                    font-size: 13px;
                    color: #333;
                    min-width: 100px;
                    font-weight: normal;
                }
            }

            .evaluateTag {
                display: flex;
                flex-wrap: wrap;

                /deep/ .el-checkbox-button {
                    display: block;
                    margin-right: 20px;
                    margin-bottom: 15px;
                }

                /deep/ .el-checkbox-button__inner {
                    border: 1px solid #dcdfe6 !important;
                    border-radius: 4px;
                    padding: 8px 15px;
                    font-size: 13px;
                    box-shadow: none;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/transaction/orderManagement/mallOrderDetails.vue